import { useCallback, useState } from 'react';
import { IAlert } from '../../../graphql/schema/p4types';

export const useHeaderAlerts: () => [Array<IAlert>, (alert: IAlert) => void, (alert: IAlert) => void] = () => {
  const [headerAlerts, setHeaderAlerts] = useState<Array<IAlert>>([]);

  const addHeaderAlert = useCallback((alert: IAlert) => {
    setHeaderAlerts((prevState) => {
      if (
        prevState.some(
          (existingAlert) =>
            existingAlert.title === alert.title &&
            existingAlert.message === alert.message &&
            existingAlert.alertType === alert.alertType
        )
      ) {
        //If there's already an alert mounted with the same details, ignore the new one. (Prevent rapid temporary-save triggers from displaying the same alert twice).
        return prevState;
      }
      const newAlerts = [...prevState];
      newAlerts.push(alert);
      return newAlerts;
    });
  }, []);

  const removeHeaderAlert = useCallback((alert: IAlert) => {
    //Just filter out the alert with matching UUID
    setHeaderAlerts((prevState) => {
      return prevState.filter((existingAlert) => existingAlert.uuid !== alert.uuid);
    });
  }, []);

  return [headerAlerts, addHeaderAlert, removeHeaderAlert];
};
